import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { STRATEGIES_QUERY_KEY } from "./useStrategies";

type StrategyResponse = components["schemas"]["StrategyResponse"];

export type RestoreStrategyVariables = {
  strategyId: string;
};

export function useRestoreStrategy() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<StrategyResponse, Error, RestoreStrategyVariables>({
    mutationFn: async ({ strategyId }) => {
      const { data, error } = await client.POST("/api/strategies/{strategy_id}/restore", {
        params: { path: { strategy_id: strategyId } },
      });
      if (error !== undefined) {
        throw new Error(`Failed to restore strategy ${strategyId}`);
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: STRATEGIES_QUERY_KEY });
    },
  });
}
